import { FormDisabled } from './components/SpecialPages/components/FormDisabled/FormDisabled'
import {
  getToken,
  getUser,
  loginUserForStore
} from '../../store/actions/user&balance'
import { PlugError } from './components/SpecialPages/components/PlugError/PlugError'
import { Notification } from './components/SpecialOfferV2/Notification/Notification'
import { createOrder, setReservation } from '../../store/actions/createOrder'
import { getCountSales, getPromoResult } from '../../store/actions/promocode'
import { SpecialOfferV2 } from './components/SpecialOfferV2/SpecialOfferV2'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { PayDetails } from './components/PayDetails/PayDetails'
import React, { useEffect, useMemo, useState } from 'react'
import { getFrameById } from '../../store/actions/frame'
import LoginModal from '../Login/LoginModal/LoginModal'
import { useDispatch, useSelector } from 'react-redux'
import { Spinner } from '../../uikit/Spinner/Spinner'
import { Header } from './components/Header/Header'
import { Main } from './components/Main/Main'
import styles from './PayFormV2.module.scss'
import queryString from 'query-string'

export const PayFormV2 = ({
  active,
  setActive,
  setPayment,
  pActive,
  setPActive,
  setNoIframe,
  promoRes,
  setPromoRes,
  promocode,
  setPromocode,
  promocode_id,
  setPromocode_id,
  setErrorCode
}) => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [inputsError, setInputsError] = useState({
    name: true,
    phone: true,
    email: true
  })
  const [payment_method_id, setPayment_method_id] = useState(0)
  const [price, setPrice] = useState(0)
  const [user, setUser] = useState({})
  const [promoCount, setPromoCount] = useState(false)
  const [promoEr, setPromoEr] = useState('')
  const [countSalesStatus, setCountSalesStatus] = useState(false)
  const [countSalesError, setCountSalesError] = useState('')
  const [countSalesLink, setCountSalesLink] = useState('')
  const [currency, setCurrency] = useState('')
  const [card_save_status, setCard_save_status] = useState(false)
  const [loginModalActive, setLoginModalActive] = useState(false)
  const [bindingProduct, setBindingProduct] = useState(false)
  const [userKey, setUserKey] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [pmidForPaytabs, setPmidForPaytabs] = useState(null)
  const [accept_license, setAccept_license] = useState(false)
  const [accept_oferta, setAccept_oferta] = useState(false)
  const [accept_adv, setAccept_adv] = useState(false)
  const [limitSalesStatus, setLimitSalesStatus] = useState(false)
  const [checkedSpecialOffer, setCheckedSpecialOffer] = useState(false)
  const [duration, setDuration] = useState('')
  const [durationErr, setDurationErr] = useState(false)
  const [showNotification, setShowNotification] = useState(false)
  const [selectedMethod, setSelectedMethod] = useState(null)
  const [hasNoPm, setHasNoPm] = useState(false)
  const [accept_special_offer_oferta, setAccept_special_offer_oferta] =
    useState(false)

  const navigate = useNavigate()

  const result = useSelector((state) => state.result)
  const loading = useSelector((state) => state.loading)
  const isError = useSelector((state) => state.error)

  const dispatch = useDispatch()

  const { id } = useParams()
  const location = useLocation()
  const user_id = user?.user_id
  const query = queryString.parse(location.search)
  const utm_source = new URLSearchParams(location.search).get('utm_source')
  const utm_medium = new URLSearchParams(location.search).get('utm_medium')
  const utm_campaign = new URLSearchParams(location.search).get('utm_campaign')
  const utm_content = new URLSearchParams(location.search).get('utm_content')
  const utm_term = new URLSearchParams(location.search).get('utm_term')

  const ukey =
    new URLSearchParams(location.search).get('ukey') || user?.ukey || userKey
  const url = window.location.href
  const payMethodId = new URLSearchParams(location.search).get('pm_id')
  const urlOrgin = new URL(url).origin
  const productsParams = new URLSearchParams(location.search).get('products')
  const productsSign = new URLSearchParams(location.search).get('products_sign')
  const preOrderId = new URLSearchParams(location.search).get('pre_order_id')

  const finsovetnik =
    urlOrgin === process.env.REACT_APP_PROD_FA_URL ||
    urlOrgin === process.env.REACT_APP_TEST_FA_URL

  const checkedProducts = Array.isArray(query.product)
    ? query.product?.map((el) => `product=${el}`).join('&')
    : query.product
        ?.split()
        .map((el) => `product=${el}`)
        .join('&')

  useEffect(() => {
    dispatch(
      getFrameById(
        id,
        checkedProducts,
        payMethodId || pmidForPaytabs,
        productsParams,
        productsSign,
        preOrderId
      )
    )
  }, [
    id,
    checkedProducts,
    payMethodId,
    productsParams,
    productsSign,
    preOrderId,
    pmidForPaytabs
  ])

  const products = result?.frame_products

  const disabled =
    (result?.disabled || typeof result === 'string') && !result?.limit_sales
  const frame_id = result?.id
  const company_id = result?.frame_companies?.find((el) => el)?.company_id
  const checkLimits = result?.limit_sales

  const specialOffer = useMemo(() => {
    if (products?.length) {
      const specialOfferProduct = products.find(
        (el) => el.special_offer === true
      )
      return specialOfferProduct
    }
    return null
  }, [products])

  const productsList = useMemo(() => {
    if (specialOffer && !checkedSpecialOffer) {
      const newProducts = products.filter(
        (el) => el.product_id !== specialOffer.product_id
      )

      return newProducts
    }
    return null
  }, [specialOffer, products, checkedSpecialOffer])

  const checkedProductsParams = useMemo(() => {
    if (productsList) {
      const checkedProducts = productsList
        ?.map((el) => `product=${el.product_id}`)
        .join('&')

      return checkedProducts
    }
    return null
  }, [productsList])

  const prodForPay = useMemo(() => {
    const info = productsList ?? products
    const productNames = info
      ?.map((item) => item.product_info?.name)
      ?.join('; ')
    return productNames?.length > 240
      ? productNames.slice(0, 240) + '...'
      : productNames
  }, [productsList, products])

  const oldPrice = useMemo(() => {
    const currProducts = productsList || products
    return currProducts?.reduce(
      (sum, el) =>
        el.price === null ? sum + el.product_info.price : sum + el.price,
      0
    )
  }, [result, productsList, products])

  const newPrice = useMemo(() => {
    return promoRes?.products?.reduce((sum, el) => sum + el.new_price, 0)
  }, [promoRes])

  const balance_status = result?.balance_status || null

  const count_sales_status = result?.count_sales_status

  const token = localStorage.getItem('token')

  const isIpOrAck = process.env.REACT_APP_IS_IP_OR_ACK === 'true'

  useEffect(() => {
    if (!isIpOrAck) {
      async function getFastSession() {
        const res = await getUser(ukey, balance_status, finsovetnik)
        setUser(res.data)
      }
      if ((!name && !email && !phone) || !loginModalActive) {
        getFastSession()
      }
    }
  }, [balance_status, loginModalActive, finsovetnik, isIpOrAck])

  useEffect(() => {
    async function getSession() {
      const res = await getToken(finsovetnik)
      localStorage.setItem('token', res.data.token)
      if (!res.data.authorized || !res.data.token) {
        setLoginModalActive(true)
      } else {
        setLoginModalActive(false)
      }
    }
    if (result?.auth_type === 'C' || result?.auth_type === 'A') {
      getSession()
    }
  }, [result.auth_type, finsovetnik])

  useEffect(() => {
    setPrice(oldPrice ?? 0)
    if (promoRes?.success) {
      if (Number.isInteger(newPrice)) {
        setPrice(newPrice)
      } else {
        setPrice(+newPrice.toFixed(2))
      }
    }
    if (promoRes?.max_count_uses) {
      setPromoCount(true)
    } else {
      setPromoCount(false)
    }
  }, [oldPrice, newPrice, promoRes])

  useEffect(() => {
    if (result?.bind_required) {
      setCard_save_status(true)
      setBindingProduct(true)
    }
  }, [result])

  async function handleCreateOrder(e, payId) {
    e.preventDefault()
    setIsLoading(true)
    if (price) {
      let orderDetails = {
        name,
        phone,
        email,
        company_id,
        frame_id,
        price,
        currency_id: currency,
        payment_method_id: payId ? payId : payment_method_id,
        user_id,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term,
        query,
        url,
        checkedProducts: checkedProductsParams || checkedProducts,
        prodForPay,
        promocode_id,
        ukey,
        balance_reserve_id: null,
        balance_summ: null,
        card_save_status,
        token,
        bindingProduct,
        productsParams,
        productsSign,
        accept_license,
        accept_oferta,
        accept_adv,
        duration,
        accept_special_offer_oferta
      }

      const handleOrderCreation = async (userIdForStore) => {
        if (userIdForStore) {
          orderDetails = { ...orderDetails, user_id: userIdForStore }
        }

        const res = await createOrder(orderDetails)
        if (res?.data) {
          setPayment(res.data)
        } else {
          setErrorCode(res?.response?.status)
          navigate('/fail')
        }
        setActive(false)
        setEmail('')
        setPhone('')
        setName('')
        setPActive(!pActive)
        window.scrollTo(0, 0)
      }

      if (result?.products_required && !user_id) {
        const resUser = await loginUserForStore({ email, phone })
        if (resUser?.data?.user_id) {
          await handleOrderCreation(resUser.data.user_id)
        }
      } else {
        await handleOrderCreation()
      }
    }
  }

  const handleReservation = async (e, payId) => {
    e.preventDefault()
    const res = await setReservation(email, frame_id)

    if (res?.data.result === 'Wait 5 minutes') {
      setCountSalesStatus(true)
      setLimitSalesStatus(true)
      setCountSalesError(
        `К сожалению, все товары в данный момент зарезервированы.
           Пожалуйста, подождите 5 минут — если кто-то не завершит оплату, они станут доступны снова.`
      )
    } else if (res?.data.result === 'Order already exist') {
      setCountSalesStatus(true)
      setLimitSalesStatus(true)
      setCountSalesError(
        'На данный адрес электронной почты уже оформлен заказ. Пожалуйста, попробуйте снова через 5 минут.'
      )
    } else if (res?.data.result === 'False') {
      setCountSalesStatus(true)
      setLimitSalesStatus(true)
      setCountSalesError('К сожалению, все товары уже распроданы.')
    } else if (res?.data.result === 'Frame not found') {
      setCountSalesStatus(true)
      setLimitSalesStatus(true)
      setCountSalesError('Ошибка: фрейм не найден')
    } else if (res?.data.result === 'Success') {
      setCountSalesStatus(false)
      setLimitSalesStatus(false)
      handleCreateOrder(e, payId)
    }
  }

  async function handleCheckSalesCount(e, payId) {
    e.preventDefault()
    const res = await getCountSales(email, frame_id)
    if (res.data.result.success === false) {
      setCountSalesStatus(true)
      setCountSalesError(res.data.result.error_text)
      setCountSalesLink(res.data.result.link)
    } else if (checkLimits) {
      handleReservation(e, payId)
    } else {
      handleCreateOrder(e, payId)
    }
  }

  async function handleCheckPromo(e, payId) {
    e.preventDefault()
    const res = await getPromoResult(
      promocode,
      frame_id,
      checkedProducts || checkedProductsParams,
      payment_method_id
    )
    if (res.data.result === 'Promocode count ended') {
      setPromoEr('Действие промокода закончилось')
    } else if (res.data.result === 'Promocode not found') {
      setPromoEr('Срок действия промокода закончился')
    } else if (count_sales_status) {
      handleCheckSalesCount(e, payId)
    } else if (checkLimits) {
      handleReservation(e, payId)
    } else {
      handleCreateOrder(e, payId)
    }
  }

  const handleSubmit = (e, payId) => {
    e.preventDefault()

    promoCount
      ? handleCheckPromo(e, payId)
      : count_sales_status
        ? handleCheckSalesCount(e, payId)
        : checkLimits
          ? handleReservation(e, payId)
          : handleCreateOrder(e, payId)
  }

  const handlePromoWithSpecialOffer = async (checked) => {
    const checkedProducts = products
      .filter((el) => el.product_id !== specialOffer.product_id)
      ?.map((el) => `product=${el.product_id}`)
      .join('&')

    const checkedProds = !checked ? checkedProducts : null

    const res = await getPromoResult(
      promocode,
      frame_id,
      checkedProds,
      payment_method_id
    )
    setPromoRes(res?.data.result)
  }

  const handleShowNotification = () => {
    setShowNotification(true)
    setTimeout(() => {
      setShowNotification(false)
    }, 2000)
  }

  return (
    <div className={styles.root} data-testid="root">
      {loading ? (
        <Spinner />
      ) : isError ? (
        <PlugError />
      ) : disabled ? (
        <FormDisabled />
      ) : (
        active && (
          <div className={styles.content} data-testid="content">
            <Header />

            <div className={styles.main} data-testid="main">
              <Main
                name={name}
                setName={setName}
                phone={phone}
                setPhone={setPhone}
                email={email}
                setEmail={setEmail}
                setInputsError={setInputsError}
                user={user}
                finsovetnik={finsovetnik}
                bindingProduct={bindingProduct}
                countSalesStatus={countSalesStatus}
                products={productsList ?? products}
                promoRes={promoRes}
                currency={currency}
                payment_method_id={payment_method_id}
                setPayment_method_id={setPayment_method_id}
                payMethodId={payMethodId}
                setNoIframe={setNoIframe}
                setCurrency={setCurrency}
                duration={duration}
                setDuration={setDuration}
                setDurationErr={setDurationErr}
                setPmidForPaytabs={setPmidForPaytabs}
                selectedMethod={selectedMethod}
                setSelectedMethod={setSelectedMethod}
                hasNoPm={hasNoPm}
                setHasNoPm={setHasNoPm}
              />
              <div className={styles.aside} data-testid="aside">
                <PayDetails
                  price={price}
                  currency={currency}
                  products={productsList ?? products}
                  promoRes={promoRes}
                  result={result}
                  card_save_status={card_save_status}
                  setCard_save_status={setCard_save_status}
                  countSalesStatus={countSalesStatus}
                  accept_license={accept_license}
                  accept_oferta={accept_oferta}
                  accept_adv={accept_adv}
                  setAccept_license={setAccept_license}
                  setAccept_oferta={setAccept_oferta}
                  setAccept_adv={setAccept_adv}
                  countSalesLink={countSalesLink}
                  inputsError={inputsError}
                  promoEr={promoEr}
                  bindingProduct={bindingProduct}
                  isLoading={isLoading}
                  limitSalesStatus={limitSalesStatus}
                  handleSubmit={handleSubmit}
                  setPromoRes={setPromoRes}
                  checkedProducts={checkedProducts}
                  promocode={promocode}
                  setPromocode={setPromocode}
                  setPromocode_id={setPromocode_id}
                  setPromoEr={setPromoEr}
                  payment_method_id={payment_method_id}
                  checkedProductsParams={checkedProductsParams}
                  durationErr={durationErr}
                  countSalesError={countSalesError}
                  hasNoPm={hasNoPm}
                />

                {specialOffer && (
                  <>
                    <SpecialOfferV2
                      specialOffer={specialOffer}
                      checkedSpecialOffer={checkedSpecialOffer}
                      setCheckedSpecialOffer={setCheckedSpecialOffer}
                      handlePromo={
                        promoRes?.success ? handlePromoWithSpecialOffer : null
                      }
                      handleShowNotification={handleShowNotification}
                      currency={currency}
                      result={result}
                      accept_special_offer_oferta={accept_special_offer_oferta}
                      setAccept_special_offer_oferta={
                        setAccept_special_offer_oferta
                      }
                    />
                  </>
                )}
              </div>
            </div>

            {showNotification && (
              <div
                className={`${styles.notifyWrapper} ${showNotification ? styles.show : ''}`}
                data-testid="notifyWrapper"
              >
                <Notification onClose={() => setShowNotification(false)} />
              </div>
            )}
          </div>
        )
      )}
      {loginModalActive && (
        <LoginModal
          active={loginModalActive}
          setLoginModalActive={setLoginModalActive}
          setUserKey={setUserKey}
        />
      )}
    </div>
  )
}
